<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'background-image-attachment',
    mixins: [baseOption],

    data() {
        return {
            customAttributeProp: 'background-attachment',
            displayName: 'Attachment',
            tailwindDefinitionProp: 'backgroundAttachment',
            value: '',
        };
    },

    computed: {
        options() {
            return this.themeObjectValues.map(v => ({ value: v, text: this.titleCase(v) }));
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements[0].setElementData(this.customAttributeProp, valueNew);
            this.onOptionChange(valueNew);
        },

        onSelectedElement() {
            const backgroundAttachment = this.selectedElements[0].getElementData('background-attachment');

            this.value = backgroundAttachment || 'local';
        },
    },
};
</script>
